import { ErrorMessage, React } from '@/imports-files/common/common';
import {getIn} from '@/imports-files/common/common';
import {default as Exclamation} from 'public/icons/exclamation.svg';
import {default as ErrorExclamation} from 'public/icons/error_exclamation.svg';

export function errorMessagesSection(name, FormStyle, formik, custom_class='', custom_error_90='')
{
  var backend_error_message  = getBackendError(name,formik);
  var front_error_present    = getFrontEndError(name,formik);

  return(
          < label className = {  `${FormStyle.Form__Error} ${custom_class}` } >
              <div className= { `${FormStyle.Form__ErrorSection} ${custom_error_90}` }>
                <ErrorExclamation/>
                { front_error_present ? < ErrorMessage name = { name } className= {FormStyle.Form__Error}/>
                                        : <div>{backend_error_message}</div>  
              }
              </div>
          </label>)
}

export function infoPlaceholderSection(infoPlaceholderText, FormStyle)
{
  return (
          <div className={`MessagePlaceholder ${FormStyle.Form__MessagePlaceholder}`}>
               {infoPlaceholderText != undefined ?  infoPlaceholder(infoPlaceholderText)
                                                 :  ''}
          </div>)
}

function infoPlaceholder(infoPlaceholder)
{
  return( <React.Fragment>
              <Exclamation/>
              {infoPlaceholder}
          </React.Fragment>)
}

function getBackendError(name,formik)
{

  var status_message      =   null;

  if(formik?.status != undefined )
  {
    status_message = getIn(formik.status, name)
  }

  return status_message;
}

function getFrontEndError(name,formik)
{

  var error_message      =   null;
  
  if( formik?.errors != undefined && Object.keys(formik?.errors).length > 0 ) 
  {
    error_message = getIn(formik.errors, name)
  }

  return error_message;
}
